import React from "react";
import { Modal } from '~/components/common';
import { Button } from '~/components/common';
import { trans } from '~/utilities';

export default function FavoritesModal({ modalOpen, setModalOpen, extranetLoginUrl, extranetRegisterUrl }) {
    return (
        <Modal
            open={modalOpen}
            handleClose={() => setModalOpen(false)}
            backText={trans('app.content_block.vehicles.filter.options.modal_back')}
            modalTitle='Favorieten'
            modalBody={
                <div className="row gutters-6">
                    <div className="col-12">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" className="mb-4">
                            <g fill="none" fillRule="evenodd">
                                <polygon points="0 0 20 0 20 20 0 20"/>
                                <path className="outer-heart" fill="currentColor" fillRule="nonzero" d="M13.75,2.5 C12.3,2.5 10.9083333,3.175 10,4.24166667 C9.09166667,3.175 7.7,2.5 6.25,2.5 C3.68333333,2.5 1.66666667,4.51666667 1.66666667,7.08333333 C1.66666667,10.2333333 4.5,12.8 8.79166667,16.7 L10,17.7916667 L11.2083333,16.6916667 C15.5,12.8 18.3333333,10.2333333 18.3333333,7.08333333 C18.3333333,4.51666667 16.3166667,2.5 13.75,2.5 Z"/>
                                <path className="inner-heart" fill="#fff" fillRule="nonzero" d="M10.0833333,15.4583333 L10,15.5416667 L9.91666667,15.4583333 C5.95,11.8666667 3.33333333,9.49166667 3.33333333,7.08333333 C3.33333333,5.41666667 4.58333333,4.16666667 6.25,4.16666667 C7.53333333,4.16666667 8.78333333,4.99166667 9.225,6.13333333 L10.7833333,6.13333333 C11.2166667,4.99166667 12.4666667,4.16666667 13.75,4.16666667 C15.4166667,4.16666667 16.6666667,5.41666667 16.6666667,7.08333333 C16.6666667,9.49166667 14.05,11.8666667 10.0833333,15.4583333 Z"/>
                            </g>
                        </svg>
                        <h5>{trans('app.favorites.modal.title')}</h5>
                        <p>{trans('app.favorites.modal.text')}</p>
                    </div>
                    <div className="col-12">
                        <div className="row gutters-2">
                            <div className="col-auto">
                                <Button
                                    href={extranetLoginUrl}
                                    theme="primary"
                                    title="Inloggen"
                                    textClassName={'text--sm'}
                                />
                            </div>
                            <div className="col-auto">
                                <Button
                                    className=""
                                    theme="outline-base"
                                    title="Doorgaan zonder inloggen"
                                    onClick={() => setModalOpen(false)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="row gutters-2">
                            <div className="col-auto">
                                Nog geen account?
                            </div>
                            <div className="col-auto">
                                <a href={extranetRegisterUrl}>Maak een account aan</a>
                            </div>
                        </div>
                    </div>
                </div>
            }
        />
    );
}
